import { Link } from "react-router-dom";
import img1 from "../../../assets/img/icon/icon-1.png";
import img2 from "../../../assets/img/icon/icon-2.png";
import img3 from "../../../assets/img/icon/icon-3.png";
import img4 from "../../../assets/img/icon/icon-4.png";
import img5 from "../../../assets/img/icon/icon-5.png";
import img6 from "../../../assets/img/icon/icon-6.png";
import img7 from "../../../assets/img/icon/icon-7.png";
import img8 from "../../../assets/img/icon/icon-8.png";
import img9 from "../../../assets/img/icon/icon-9.png";
import img10 from "../../../assets/img/icon/icon-10.png";

import { GoArrowRight } from "react-icons/go";

const ourService = [
  { id: 1, name: "Landscape Design", img_url: img1, url: "landscape-design" },
  { id: 2, name: "Hardscape", img_url: img2, url: "hardscape" },
  { id: 3, name: "Landscape Lighting", img_url: img3, url: "landscape-lighting" },
  { id: 4, name: "Softscape", img_url: img4, url: "softscape" },
  { id: 5, name: "Plantation", img_url: img5, url: "plantation" },
  { id: 6, name: "Replanting", img_url: img6, url: "replanting" },
  { id: 7, name: "Lawn Development and Maintenance", img_url: img7, url: "lawn-development-and-maintenance" },
  { id: 8, name: "Horticultural Maintenance", img_url: img8, url: "horticultural-maintenance" },
  { id: 9, name: "Vertical & Terrace Garden", img_url: img9, url: "vertical-and-terrace-garden" },
  { id: 10, name: "Irrigation System", img_url: img10, url: "irrigation-system" }
];

const Landscaping = () => {
  return (
    <>
      <section className="sectionPD">
        <div className="container">
          <div className="fisherman-content">
            <h6>Main Services</h6>
            <h1>Transforming Spaces with Expert Landscaping</h1>
            <p>
              Our landscaping services are designed to transform your outdoor
              spaces into beautiful, functional environments. From design and
              planting to maintenance and irrigation, we bring your vision to
              life with expert care.
            </p>
          </div>

          <div className="landCardList">
            {ourService.map((item) => {
              return (
                <div className="landCard" key={item.id}>
                  <img
                    src={item.img_url}
                    alt={item.name}
                    className="img-fluid"
                  />
                  <div className="text">
                    <h5>{item.name}</h5>
                    <Link to={`${item.url}`}>
                      <GoArrowRight />
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default Landscaping;
